module.exports = __webpack_public_path__ + "static/media/longText.2b80a202.svg";